const rows = [
  { label: "Processing Time", fpc: "2–9 Business Days", agency: "Same-day appointment only" },
  { label: "Appointment Required", fpc: "No", agency: "Yes — very limited availability" },
  { label: "Travel to Seattle", fpc: "No", agency: "Yes — 1,600+ miles flight required" },
  { label: "Dedicated Agent", fpc: "Yes — personal case manager", agency: "No — government counter only" },
  { label: "Document Review", fpc: "Full pre-submission review", agency: "You handle yourself" },
  { label: "Status Updates", fpc: "Daily — phone or email", agency: "No updates provided" },
  { label: "Cost", fpc: "Service fee + govt. fee", agency: "Flight + hotel + govt. fee" },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Comparison</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. Seattle Regional Agency
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Fairbanks residents face a 1,600+ mile flight to reach the Seattle Passport Agency. Fast Passport Center eliminates that trip entirely.
          </p>
        </div>

        <div className="bg-amber-50 border border-[#F6C344]/40 rounded-lg p-5 md:p-6 mb-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <h3 className="font-bold text-base text-[#1A365D] mb-1">Passport Agency Appointment Not Available?</h3>
              <p className="text-sm text-gray-600">Don't let a booked-out agency appointment block your travel plans. We bypass the agency bottleneck with reserved daily courier slots — faster and no appointment roulette.</p>
            </div>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
            >
              Get Started <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#F7F8FA]">
                <th className="text-left px-5 py-4 font-semibold text-[#1A365D] w-1/3">Feature</th>
                <th className="px-5 py-4 font-bold text-[#1A365D] text-center bg-[#EEF2F8] border-l border-gray-200">
                  Fast Passport Center
                </th>
                <th className="px-5 py-4 font-semibold text-gray-400 text-center border-l border-gray-200">
                  Seattle Passport Agency
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]/50"}>
                  <td className="px-5 py-3.5 text-gray-600 font-medium border-t border-gray-100">{row.label}</td>
                  <td className="px-5 py-3.5 text-center border-t border-gray-100 border-l border-gray-200 bg-[#EEF2F8]/30">
                    <span className="text-[#1A365D] font-semibold">{row.fpc}</span>
                  </td>
                  <td className="px-5 py-3.5 text-center border-t border-gray-100 border-l border-gray-200 text-gray-500">
                    {row.agency}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0f2440] text-white font-bold px-8 py-4 rounded-md transition-all whitespace-nowrap"
          >
            Start With Fast Passport Center <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}